import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Modal, Field } from './common';
import { useI18n } from '../i18n/I18nContext';
import api from '../api/client';

// Subtract (consume) a quantity of raw material with an optional note.
export default function UseMaterialModal({ material, onClose, onDone }) {
  const { t } = useI18n();
  const [qty, setQty] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => { setQty(''); setNote(''); }, [material?.code]);

  const submit = async () => {
    const n = parseFloat(qty);
    if (!(n > 0)) { toast.error(t('term.qtyInvalid')); return; }
    if (n > (material.stock || 0)) { toast.error(t('mat.tooMuch').replace('{n}', `${material.stock} ${material.unit || ''}`)); return; }
    setSaving(true);
    try {
      const upd = await api.adjustMaterial(material.code, -n, note.trim() || undefined);
      onDone(upd);
      toast.success(`${t('mat.used')} ${n} ${upd.unit || ''} · ${upd.name}`, { description: `${t('mat.inStock')}: ${upd.stock} ${upd.unit || ''}` });
      onClose();
    } catch (e) {
      toast.error(t('toast.stockFailed'), { description: e?.response?.data?.detail || e.message });
    } finally { setSaving(false); }
  };

  return (
    <Modal open={!!material} onClose={onClose} title={material ? `${t('mat.useTitle')} · ${material.name}` : ''}
      footer={<>
        <button className="kmt-btn-ghost" onClick={onClose} data-testid="use-material-cancel">{t('mat.cancel')}</button>
        <button className="kmt-btn-gold" disabled={saving} onClick={submit} data-testid="use-material-submit">{saving ? '…' : t('mat.confirmUse')}</button>
      </>}>
      {material && (
        <div className="space-y-4" data-testid="use-material-modal">
          <div className="flex items-baseline justify-between">
            <span className="text-sm" style={{ color: 'var(--kmt-muted)' }}>{t('mat.inStock')}</span>
            <span className="font-display font-bold" style={{ fontSize: 24, color: 'var(--kmt-gold)' }} data-testid="use-material-stock">{material.stock} {material.unit}</span>
          </div>
          <Field label={`${t('mat.qty')} (${material.unit || ''})`}>
            <input className="kmt-input" type="number" min="0" step="any" inputMode="decimal" autoFocus value={qty}
              onChange={(e) => setQty(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && submit()} data-testid="use-material-qty" />
          </Field>
          <Field label={t('mat.note')}>
            <input className="kmt-input" value={note} maxLength={120} onChange={(e) => setNote(e.target.value)} data-testid="use-material-note" />
          </Field>
        </div>
      )}
    </Modal>
  );
}
